<template>
  <div class="card folder mb-2">
    <router-link
      :to="{ name: 'FileTypesPreviewPage', params: { uuid: file.uuid } }"
    >
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div>
            <i class="item-icon me-3" :class="getFileIcon()"></i>
          </div>
          <div class="flex-fill">{{ file.value }}</div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: ["file"],
  methods: {
    getFileIcon() {
      switch (this.file.value.toLowerCase()) {
        case "immagini": {
          return "far fa-image";
        }
        case "documenti": {
          return "fas fa-folder";
        }
        case "video": {
          return "fas fa-film";
        }
        case "audio": {
          return "far fa-file-audio";
        }
        default: {
          return "fas fa-folder";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.folder {
  cursor: pointer;
  font-size: 25px;
  text-transform: capitalize;

  a {
    text-decoration: none;
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/components/Folder.vue